import { render, staticRenderFns } from "./NewCalendarItem.vue?vue&type=template&id=21a4f9ab&scoped=true"
import script from "./NewCalendarItem.ts?vue&type=script&lang=ts&external"
export * from "./NewCalendarItem.ts?vue&type=script&lang=ts&external"
import style0 from "./NewCalendarItem.scss?vue&type=style&index=0&id=21a4f9ab&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a4f9ab",
  null
  
)

export default component.exports